export function findModel(models, id) {
  return (models || []).find(m => m.name === id || m.aliases?.includes(id)) || null;
}

export function supportsImageTask(model, edit = false) {
  return Boolean(model?.output_modalities?.includes('image') &&
    model?.input_modalities?.includes(edit ? 'image' : 'text') &&
    model?.supported_endpoints?.includes(edit ? '/v1/images/edits' : '/v1/images/generations'));
}

export function resolveGenerationRequest(draft, model) {
  if (typeof draft.prompt !== 'string' || !draft.prompt.trim() || draft.prompt.length > 32000) throw new Error('Write a prompt between 1 and 32000 characters.');
  if (!model || (draft.modelId !== model.name && !model.aliases?.includes(draft.modelId))) throw new Error('Choose an available image model. Model metadata is required.');
  const edit = Boolean(draft.referenceMetadata);
  if (!supportsImageTask(model, edit)) throw new Error(edit ? 'This model cannot edit a reference image. Choose a model with image input and editing support.' : 'This model does not support image generation.');
  const size = String(draft.size || '1024x1024');
  const match = /^(\d+)x(\d+)$/.exec(size);
  if (!match || match.slice(1).some(n => Number(n) < 256 || Number(n) > 2048)) throw new Error('Image dimensions must be between 256 and 2048 pixels.');
  const outputCount = draft.outputCount ?? 1;
  if (!Number.isInteger(outputCount) || outputCount < 1 || outputCount > 6) throw new Error('Choose 1 to 6 outputs.');
  // The image POST endpoints do not document a negative_prompt parameter.
  if (draft.negativePrompt) throw new Error('Separate negative prompts are not supported by this image endpoint. Clear this option; your prompt will not be changed.');
  const quality = draft.quality || 'standard';
  if (!['standard','hd','low','medium','high'].includes(quality)) throw new Error('Unsupported image quality.');
  const ref = draft.referenceMetadata;
  const referenceMetadata = ref ? Object.freeze({name:String(ref.name || 'reference'),type:String(ref.type || ''),size:Number(ref.size),width:Number(ref.width) || null,height:Number(ref.height) || null}) : null;
  return Object.freeze({task:edit ? 'edit' : 'generate',prompt:draft.prompt,modelId:model.name,size,quality,outputCount,referenceMetadata,negativePrompt:'',referenceIntent:edit && draft.referenceIntent === 'style' ? 'style' : 'identity'});
}
